import { Actions } from './streets.actions'
import { fromJS } from 'immutable'
import * as StreetsTypes from './streets.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page_size: 20,
      page: 1,
    },
    total: 0,
    results: 0,
  },
  createStreet: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  updateStreet: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
})

export function streetsReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case StreetsTypes.UPDATE_STREET_REQUEST: {
      return state.setIn(['updateStreet', 'isLoading'], true)
    }

    case StreetsTypes.UPDATE_STREET_SUCCESS: {
      return state.setIn(['updateStreet', 'isLoading'], false)
    }

    case StreetsTypes.UPDATE_STREET_FAILURE: {
      return state.setIn(['updateStreet', 'isLoading'], false)
    }

    case StreetsTypes.CREATE_STREET_REQUEST: {
      return state.setIn(['createStreet', 'isLoading'], true)
    }

    case StreetsTypes.CREATE_STREET_SUCCESS: {
      return state.setIn(['createStreet', 'isLoading'], false)
    }

    case StreetsTypes.CREATE_STREET_FAILURE: {
      return state.setIn(['createStreet', 'isLoading'], false)
    }

    case StreetsTypes.DELETE_STREET_REQUEST: {
      return state
    }

    case StreetsTypes.DELETE_STREET_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case StreetsTypes.DELETE_STREET_FAILURE: {
      return state
    }

    case StreetsTypes.FETCH_STREETS_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case StreetsTypes.FETCH_STREETS_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'results'], fromJS(action.results))
    }

    case StreetsTypes.FETCH_STREETS_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case StreetsTypes.FETCH_STREET_REQUEST: {
      return state.setIn(['updateStreet', 'isLoading'], true)
    }

    case StreetsTypes.FETCH_STREET_SUCCESS: {
      return state.setIn(['updateStreet', 'isLoading'], false).setIn(
        ['updateStreet', 'data'],
        fromJS(action.payload)
          .delete('streetType')
          .delete('id')
          .set(
            'streetTypeId',
            action.payload.streetType && action.payload.streetType.id,
          ),
      )
    }

    case StreetsTypes.FETCH_STREET_FAILURE: {
      return state.setIn(['updateStreet', 'isLoading'], false)
    }

    case StreetsTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case StreetsTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
